import * as types from './types';
import _ from 'lodash';
import moment from 'moment';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  physicalForTranSummaryList: [],
  fetchPhysicalForTranSummaryListLoadingError: null,
  fetchPhysicalForTranSummaryListLoading: false,
  fetchExistingTranSummaryPreviewLoading: false,
  fetchExistingTranSummaryPreviewLoadingError: null,
  closePeriodLoading: false,
  closePeriodLoadingError: null,
  fetchOpenTransactionWarningMsgLoading: false,
  fetchOpenTransactionWarningMsg: null,
  fetchOpenTransactionWarningMsgLoadingError: null,
  showWarningDialog: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING:
      return {
        ...state,
        fetchPhysicalForTranSummaryListLoading: action.payload,
      };
    case types.GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA:
      let physicalForTranSummaryList =
        action.payload && Array.isArray(action.payload) && action.payload.length
          ? action.payload.map(item => ({
              ...item,
              [TransactionSummaryEnum.LastDate]: item[
                TransactionSummaryEnum.LastDate
              ]
                ? moment(item[TransactionSummaryEnum.LastDate]).format(
                    DATE_FORMAT_FOR_UI
                  )
                : '',
            }))
          : [];
      return {
        ...state,
        physicalForTranSummaryList: physicalForTranSummaryList,
      };
    case types.GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING_ERROR:
      if (
        _.has(action.payload, 'response.data.Errors') &&
        action.payload.response.data.Errors.length
      ) {
        const fetchPhysicalForTranSummaryListLoadingError =
          action.payload.response.data.Errors;

        return {
          ...state,
          fetchPhysicalForTranSummaryListLoadingError,
        };
      }
      return {
        ...state,
        fetchPhysicalForTranSummaryListLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while loading transaction summary list. Please try again.',
        },
      };
    case types.CLEAR_CREATE_TRANSACTION_SUMMARY_ERROR:
      return {
        ...state,
        fetchPhysicalForTranSummaryListLoadingError: null,
        fetchExistingTranSummaryPreviewLoadingError: null,
        closePeriodLoadingError: null,
        fetchOpenTransactionWarningMsgLoadingError: null,
      };
    case types.GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING:
      return {
        ...state,
        fetchExistingTranSummaryPreviewLoading: action.payload,
      };
    case types.GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING_ERROR:
      if (
        _.has(action.payload, 'response.data.Errors') &&
        action.payload.response.data.Errors.length
      ) {
        const fetchExistingTranSummaryPreviewLoadingError =
          action.payload.response.data.Errors;

        return {
          ...state,
          fetchExistingTranSummaryPreviewLoadingError,
        };
      }
      return {
        ...state,
        fetchExistingTranSummaryPreviewLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while preview transaction summary list. Please try again.',
        },
      };
    case types.CLOSE_PERIOD_LOADING:
      return {
        ...state,
        closePeriodLoading: action.payload,
      };
    case types.CLOSE_PERIOD_LOADING_ERROR:
      if (
        _.has(action.payload, 'response.data.Errors') &&
        action.payload.response.data.Errors.length
      ) {
        const closePeriodLoadingError = action.payload.response.data.Errors;

        return {
          ...state,
          closePeriodLoadingError,
        };
      }
      return {
        ...state,
        closePeriodLoadingError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while close period. Please try again.',
        },
      };
    case types.GET_OPEN_TRANSACTION_WARNING_MSG_LOADING:
      return {
        ...state,
        fetchOpenTransactionWarningMsgLoading: action.payload,
      };
    case types.GET_OPEN_TRANSACTION_WARNING_MSG_DATA:
      return {
        ...state,
        fetchOpenTransactionWarningMsg: action.payload,
        showWarningDialog:
          _.has(action.payload, 'Data.WarningMessage') &&
          action.payload.Data.WarningMessage > '',
      };
    case types.GET_OPEN_TRANSACTION_WARNING_MSG_LOADING_ERROR:
      if (
        _.has(action.payload, 'response.data.Errors') &&
        action.payload.response.data.Errors.length
      ) {
        const fetchOpenTransactionWarningMsgLoadingError =
          action.payload.response.data.Errors;

        return {
          ...state,
          fetchOpenTransactionWarningMsgLoadingError,
        };
      }
      return {
        ...state,
        fetchOpenTransactionWarningMsgLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while print Transaction Summary. Please try again.',
        },
      };
    case types.SHOW_WARNING_MSG:
      return {
        ...state,
        showWarningDialog: action.payload,
      };
    case types.CLEAR_GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA:
      return {
        ...state,
        physicalForTranSummaryList: [],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/CreateTransaction/reducer.js